import script from "./MigratePreviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MigratePreviewModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__